<template>
    <div>
        <canvas id="qvCont" ref="cont" width="340" height="170"> </canvas>
    </div>
</template>

<script>
import * as THREE from "three";
export default {
    props: ["image"],
    data: () => ({
        APP_DATA: window.APP_DATA,
        mesh: null,
        lon: 0,
        lat: 0,
        camera: null,
        renderer: null,
        scene: null,
    }),
    watch: {
        image: function (newVal, oldVal) {
            if (newVal) {
                let data = this.APP_DATA.scenes.filter(
                    (n) => n.id == newVal
                )[0];
                const texture = new THREE.TextureLoader().load(
                    `app/epi/${data.id}.min.jpg`
                );
                const material = new THREE.MeshBasicMaterial({ map: texture });
                this.mesh.material = material;
                this.mesh.needsUpdate = true;
                this.lon = Math.PI - data.initialViewParameters.yaw - 0.4;

                this.renderer.setSize(
                    this.$refs.cont.clientWidth,
                    this.$refs.cont.clientHeight
                );
                if (!oldVal) this.update();
            }
        },
    },
    methods: {
        update() {
            if (this.image) requestAnimationFrame(this.update);

            this.lon += 0.001745;

            this.lat = Math.max(-85, Math.min(85, this.lat));
            let phi = THREE.MathUtils.degToRad(90 - this.lat);
            let theta = this.lon;

            const x = 500 * Math.sin(phi) * Math.cos(theta);
            const y = 500 * Math.cos(phi);
            const z = 500 * Math.sin(phi) * Math.sin(theta);

            this.camera.lookAt(x, y, z);

            this.renderer.render(this.scene, this.camera);
        },
    },
    mounted() {
        const container = this.$refs.cont;

        this.lon = 0;

        this.camera = new THREE.PerspectiveCamera(60, 2, 1, 1100);

        this.scene = new THREE.Scene();

        const geometry = new THREE.SphereGeometry(500, 60, 40);
        // invert the geometry on the x-axis so that all of the faces point inward
        geometry.scale(-1, 1, 1);

        const material = new THREE.MeshBasicMaterial();

        this.mesh = new THREE.Mesh(geometry, material);

        this.scene.add(this.mesh);

        this.renderer = new THREE.WebGLRenderer({ canvas: container });
        this.renderer.setPixelRatio(window.devicePixelRatio);

       /*  window.addEventListener("resize", () => {
            this.renderer.setSize(
                container.clientWidth,
                container.clientHeight
            );
        }); */

        container.style.touchAction = "none";

        this.update();
    },
};
</script>

<style scoped>
#qvCont {
    width: 340px;
    height: 170px;
    border-radius: 4px;
    position: relative;
    z-index: 100;
}
@media only screen and (max-width: 860px) {
    #qvCont {
        width: 100vw !important;
        height: 30vh !important;
        border-radius: 0px;
    }
}
</style>